import { map } from 'lodash'

const dietExcludedAllergensDetailsFormInitialValues = excludedAllergens => ({
  dietExcludedAllergenIds: map(excludedAllergens, 'id'),
})

export default dietExcludedAllergensDetailsFormInitialValues
